import { defineMessages } from 'react-intl'

export const translationsCostCenter = defineMessages({
  overviewSearchStart: {
    id: 'costCenter.overview.search.start',
    defaultMessage: 'Search cost centers',
  },
  groupOverviewSearchStart: {
    id: 'costCenterGroup.overview.search.start',
    defaultMessage: 'Search for cost center groups',
  },
})
